/** PatternFly status and severity color tokens. Values follow the active theme. */

export const PF_STATUS_COLOR = {
  success: 'var(--pf-t--global--color--status--success--default)',
  danger: 'var(--pf-t--global--color--status--danger--default)',
  warning: 'var(--pf-t--global--color--status--warning--default)',
  info: 'var(--pf-t--global--color--brand--default)',
  custom: 'var(--pf-t--global--color--status--custom--default)',
} as const;

export const PF_STATUS_COLOR_SOFT = {
  success: 'color-mix(in srgb, var(--pf-t--global--color--status--success--default) 16%, transparent)',
  danger: 'color-mix(in srgb, var(--pf-t--global--color--status--danger--default) 16%, transparent)',
  warning: 'color-mix(in srgb, var(--pf-t--global--color--status--warning--default) 16%, transparent)',
  info: 'color-mix(in srgb, var(--pf-t--global--color--brand--default) 16%, transparent)',
} as const;

export const PF_SEVERITY_COLOR = {
  critical: 'var(--pf-t--global--icon--color--severity--critical--default)',
  important: 'var(--pf-t--global--icon--color--severity--important--default)',
  moderate: 'var(--pf-t--global--icon--color--severity--moderate--default)',
  minor: 'var(--pf-t--global--icon--color--severity--minor--default)',
  none: 'var(--pf-t--global--icon--color--severity--none--default)',
  undefined: 'var(--pf-t--global--icon--color--severity--undefined--default)',
} as const;
